import React from 'react'
import Drawer from '@material-ui/core/Drawer';
import { observer } from 'mobx-react'

import ReportPanel from '../ReportPanel';
import LocationPanel from '../LocationPanel';



const Content = observer(class Content extends React.Component {
    constructor() {
        super()
        this.state = {
            bottom: false,
            mode: null,
            params: null
        }
    }

    toggleDrawer(open) {
        this.setState({ bottom: open });
    }

    componentWillReceiveProps(props) {
        this.setState({ bottom: !!props.mode, mode: props.mode, params: props.params })
    }

    render() {
        let params = {}
        if (this.props.params && this.props.params.latlng) {
            params = {
                latitude: this.props.params.latlng.lat,
                longitude: this.props.params.latlng.lng
            }
        }
        return (
            <div>
                <Drawer anchor="bottom" open={this.state.bottom} onClose={function () { this.toggleDrawer(false) }.bind(this)}>
                    {this.state.mode === 'report' ?
                        <ReportPanel closePanel={function () { this.toggleDrawer(false) }.bind(this)} params={params} /> :
                        <LocationPanel params={this.state.params} closePanel={function () { this.toggleDrawer(false) }.bind(this)} />
                    }
                </Drawer>
            </div>
        )
    }
})

export default Content;